import React from "react";
import { useSelector } from "react-redux";
import { useGetUserTaskBasedBadgesQuery } from "../../../redux-toolkit/features/my-activity/myActivityApiSlice";
import BaseJourney from "./BaseJourney";

const TasksJourney = ({ currentProgress }) => {
  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;

  const { data: taskBadgesData, isLoading } =
    useGetUserTaskBasedBadgesQuery(userId);

  // Get badges from API data
  const earnedBadges = taskBadgesData?.data?.earnedBadges || [];

  // Sort badges by valueThreshold to ensure correct order
  const sortedBadges = [...earnedBadges].sort(
    (a, b) => a.valueThreshold - b.valueThreshold
  );

  // Calculate progress based on earned badges
  const earnedBadgesCount = sortedBadges.filter(
    (badge) => badge.isEarned
  ).length;
  const totalBadges = sortedBadges.length;
  const maxProgress = totalBadges || 5; // Use total badges as max progress
  const calculatedProgress = totalBadges > 0 ? earnedBadgesCount : 0;


  // Create timeline markers from badge thresholds
  const timelineMarkers =
    sortedBadges.length > 0
      ? sortedBadges.map((badge) => badge.valueThreshold.toString())
      : ["10", "20", "30", "40", "50"]; // Fallback markers

  // Transform API data to match our badge structure
  const badgeData =
    sortedBadges.length > 0
      ? sortedBadges.map((badge) => ({
          id: badge._id || badge.valueThreshold,
          image: badge.badgeImage || "",
          title: (
            badge.badgeName || `${badge.valueThreshold} Tasks`
          ).toUpperCase(),
          description: getBadgeDescription(badge.valueThreshold),
          isAchieved: Boolean(badge.isEarned),
        }))
      : []; // Empty array if no API data

  // Helper function to generate badge descriptions
  function getBadgeDescription(threshold) {
    switch (threshold) {
      case 10:
        return "First steps on your learning journey";
      case 20:
        return "Building momentum in your quest";
      case 30:
        return "Halfway through your adventure";
      case 40:
        return "Almost there, keep pushing forward";
      case 50:
        return "Master of the learning realm";
      default:
        return `Complete ${threshold} tasks to earn this badge`;
    }
  }

  // Show loading state if badges are still loading
  if (isLoading) {
    return (
      <div className="journey-container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            color: "#fff",
            fontSize: "1rem",
          }}
        >
          Loading task badges...
        </div>
      </div>
    );
  }

  return (
    <BaseJourney
      currentProgress={calculatedProgress}
      maxProgress={maxProgress}
      badgeData={badgeData}
      timelineMarkers={timelineMarkers}
      progressColor="#FFA318"
      actualScore={currentProgress} // Pass the actual task count for comparison with valueThreshold
    />
  );
};

export default TasksJourney;
